<template>
  <project-base :state="state">
    <div class="container flex justify-center">
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1106 794.90955"
          class="w-full mb-12 text-neutral-500"
        >
          <title>notify</title>
          <circle cx="455" cy="443.90955" r="342" fill="#f2f2f2" />
          <path
            d="M961.71287,244.62509l-35.67953,42.30243c-1.9249,18.22024-4.65542,38.58023-8.52527,59.93929l58.62058-60.64622.27448,1.05921c-3.33576-16.2975-8.38156-31.08319-15.017-43.65754Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M926.36527,283.73064l34.56221-40.97673c-7.5436-14.02366-17.09669-25.22594-28.5123-32.57721-.59394-.38244-1.19189-.74313-1.79023-1.10129C930.63337,214.05667,930.48746,243.29372,926.36527,283.73064Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M970.63784,414.87238l.07389,1.22739q2.99973-11.279,5.12826-22.58661l-85.0105,54.88751-.056-.55946q-2.41207,6.56777-4.95841,12.89086Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M980.76792,348.18048l.1725,1.16285a258.753,258.753,0,0,0-4.31412-60.92614l-59.73809,61.80128q-5.57764,30.00367-13.13392,57.11249Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M830.04328,244.77863a216.0522,216.0522,0,0,0-22.80842,37.0946l98.45895,112.39326c4.0539-15.76407,7.32225-31.05072,9.95257-45.3068L829.52479,245.892Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M800.27911,297.30551l.50061-1.127L901.889,408.35933q1.63224-5.76159,3.12307-11.46128L806.18975,284.09l.50773-1.1227Q803.34435,289.8904,800.27911,297.30551Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M975.99059,390.86209l.12,1.19985a309.002,309.002,0,0,0,4.77151-41.37849l-78.055,59.95055q-5.14131,18.04785-11.13863,34.65818Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M863.32243,507.46783c-13.228,23.02286-28.21712,42.48581-44.81816,58.15865,18.36228-7.40615,92.33871-40.03342,130.67759-98.87266Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M784.89834,354.40655a298.92372,298.92372,0,0,0-1.72063,39.97807l.61623-1.19674,79.29882,111.24246a371.62843,371.62843,0,0,0,19.45991-40.06245Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M924.90466,283.60624c4.44888-43.75109,4.21059-74.23726,4.20605-74.6747l.75563-.30678c-17.85267-10.34935-37.58085-9.98891-56.79654-.79076Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M884.48186,463.98653c-.53624,1.30309-1.06826,2.6143-1.613,3.90142a369.2199,369.2199,0,0,1-17.58542,36.124l85.04538-40.3282.04257,1.20514a146.38018,146.38018,0,0,0,15.82373-33.38466q2.234-6.93649,4.12082-13.9236Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M916.16465,346.11386c3.81106-21.11918,6.50255-41.24012,8.40217-59.24847l-53.02368-77.51124.55935-1.05834c-14.43947,7.1411-28.56314,19.27219-41.358,35.58973Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M861.92687,506.4818,783.20851,396.0533c1.89707,80.04747,29.22792,165.47634,30.99093,170.90915C833.10379,550.03317,848.836,529.21983,861.92687,506.4818Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M883.46584,462.00218l.08125-.04392a501.54006,501.54006,0,0,0,17.6078-51.03519l-101.358-112.457q-4.108,10.06441-7.63169,20.969a179.71113,179.71113,0,0,0-6.91194,31.97757Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M1041.92235,573.27139l-54.46112,9.82395c-13.10368,12.80531-28.19261,26.74479-44.79625,40.72707l83.83-9.32-.46419.99085c7.82563-14.67976,13.36994-29.28583,16.27952-43.20264Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M989.75589,580.84484l52.755-9.51554c3.1345-15.6123,2.92179-30.33329-1.18164-43.27621-.21352-.67337-.444-1.33255-.6764-1.99C1037.48225,529.90494,1018.722,552.32994,989.75589,580.84484Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M940.21,710.08656l-.72593.99245q9.50426-6.77368,18.35581-14.12509L857.3576,685.00673l.31372-.46659q-6.04679,3.52-12.0409,6.76586Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M990.54917,665.18227l-.60882,1.00564a258.75283,258.75283,0,0,0,35.53692-49.67629l-85.42744,9.49685q-23.43264,19.551-46.54281,35.61043Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M940.41388,489.40881a216.0523,216.0523,0,0,0-41.2263,14.02231l4.14595,149.36272c13.17683-9.55568,25.44414-19.2447,36.56272-28.54693l-.59181-134.31131Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M883.98739,510.88042l1.10436-.54868,6.32271,150.88948q4.932-3.39645,9.71554-6.83542l-4.16125-149.91391,1.10711-.54085Q891.07767,507.12444,883.98739,510.88042Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M959.64675,695.00815l-.67283,1.00066a309.00325,309.00325,0,0,0,30.06679-28.82593l-98.35449-3.61135q-15.471,10.62106-30.68437,19.589Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M798.498,712.95523c-24.87237,9.295-48.83063,14.72482-71.61294,16.20749,18.86618,6.0076,96.65223,28.06169,163.709,7.19743Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M835.72139,545.049a298.92425,298.92425,0,0,0-26.82383,29.69325l1.23791-.52868-9.877,136.25577a371.63021,371.63021,0,0,0,40.54025-18.44386Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M988.7103,579.81743c31.33158-30.85906,50.59259-54.49117,50.86809-54.831l.77766.24567c-7.149-19.35767-22.57331-31.663-43.23975-36.83473Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M842.52782,692.96219c-1.24414.66161-2.49021,1.33215-3.73068,1.976a369.21967,369.21967,0,0,1-36.58453,16.60606l91.223,23.18286-.73586.95535a146.3802,146.3802,0,0,0,33.4805-15.61992q6.1448-3.91753,12.0545-8.09548Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M942.11053,622.38564c16.40537-13.835,31.31177-27.61528,44.26083-40.27352l8.59954-93.51765,1.10584-.45836c-15.67583-3.70971-34.29113-3.37476-54.55317,1.03208Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M798.05208,711.30568,807.857,576.04706C758.2626,638.90877,724.82472,722.13722,722.71744,727.446,748.07512,726.4647,773.46694,720.4687,798.05208,711.30568Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M843.011,690.78581l.09058.018a501.53942,501.53942,0,0,0,46.11235-28.07626l-6.33811-151.26079q-9.58314,5.13139-19.25216,11.28247a179.71165,179.71165,0,0,0-25.71928,20.22025Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M759.07013,391.16687,738.21336,442.4262c3.80119,17.923,7.49758,38.13,10.41926,59.63922L785.637,426.26958l.58842.92251c-8.20991-14.46835-17.57883-26.97036-27.776-36.878Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M737.54089,439.28327l20.20394-49.65319c-11.50886-11.00523-24.05674-18.70611-37.18558-22.16887-.68307-.18012-1.36323-.33832-2.043-.494C720.064,371.70194,728.96229,399.55237,737.54089,439.28327Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M820.181,550.31856l.44965,1.14444q-.63347-11.65386-2.10431-23.06569l-63.882,78.47618-.22616-.51476q-.26388,6.99171-.73108,13.79223Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M809.20071,483.76135l.52349,1.05258a258.75218,258.75218,0,0,0-22.93494-56.60914L749.0791,505.44456q3.96952,30.25843,5.16253,58.37537Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M633.89579,432.01155a216.05266,216.05266,0,0,0-10.22568,42.32811L752.048,550.79572c-1.01724-16.24515-2.634-31.79346-4.539-46.16445L633.74683,433.23064Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M621.82505,491.16623l.12775-1.22651,130.83273,75.43479q-.22858-5.984-.57251-11.86537l-128.85163-76.7382.13584-1.22466Q622.44819,483.16678,621.82505,491.16623Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M817.85009,525.82952l.485,1.104a309.00293,309.00293,0,0,0-8.2521-40.82707L754.38086,567.2478q.689,18.75321.11956,36.4039Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M746.7417,671.55051c-5.4639,25.98418-13.70312,49.12714-24.64678,69.16382,15.17387-12.7192,75.44272-66.61462,93.71714-134.423Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M624.84722,550.22521A298.92583,298.92583,0,0,0,635.568,588.77742l.21614-1.32861,109.8003,81.284a371.62869,371.62869,0,0,0,6.1238-44.11561Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M736.11335,439.61643c-9.2923-42.98376-18.9421-71.90338-19.08163-72.318l.6238-.52533c-20.17739-4.32434-38.82807,2.11637-54.25967,16.8036Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M753.425,623.65815c-.1072,1.405-.20788,2.81649-.32808,4.20894a369.21986,369.21986,0,0,1-5.55846,39.79061l68.41542-64.64061.413,1.133a146.37943,146.37943,0,0,0,4.72975-36.64089q-.01945-7.28733-.38471-14.5155Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M747.12225,501.7646c-2.90344-21.263-6.56307-41.23053-10.3228-58.94419l-74.38563-57.3261.20484-1.17941c-11.52509,11.25459-21.20745,27.15722-28.33206,46.63055Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M745.10969,671.04413,636.113,590.35486c26.5466,75.54121,78.94487,148.3388,82.30081,152.96062C731.15966,721.372,739.68809,696.71505,745.10969,671.04413Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <path
            d="M751.84538,622.08506l.0637-.06688a501.53867,501.53867,0,0,0,.97073-53.97854l-131.1546-75.62058q-.7959,10.84134-.77652,22.30106a179.71014,179.71014,0,0,0,3.3107,32.5481Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <ellipse cx="553" cy="762.90955" rx="553" ry="32" fill="#3f3d56" />
          <path
            d="M792,774.69c0,62.194-86.691,42.9568-192.83533,42.9568S407.6173,836.88394,407.6173,774.69s86.67912-75.72061,192.82347-75.72061S792,712.496,792,774.69Z"
            transform="translate(-47 -52.54523)"
            opacity="0.1"
          />
          <path
            d="M792,759.37677c0,62.194-86.691,42.95679-192.83533,42.95679S407.6173,821.57072,407.6173,759.37677s86.67912-75.72062,192.82347-75.72062S792,697.18281,792,759.37677Z"
            transform="translate(-47 -52.54523)"
            fill="#3f3d56"
          />
          <path
            d="M812.97385,500.143s0,104.38922,5.57805,127.49828,25.49965,106.77981,25.49965,106.77981l27.09339-5.578s-4.78119-110.76413-9.56237-126.70142,5.578-81.28015,19.12474-95.62371-6.37491-23.10906-6.37491-23.10906Z"
            transform="translate(-47 -52.54523)"
            fill="#2f2e41"
          />
          <path
            d="M812.97385,500.143s0,104.38922,5.57805,127.49828,25.49965,106.77981,25.49965,106.77981l27.09339-5.578s-4.78119-110.76413-9.56237-126.70142,5.578-81.28015,19.12474-95.62371-6.37491-23.10906-6.37491-23.10906Z"
            transform="translate(-47 -52.54523)"
            opacity="0.1"
          />
          <path
            d="M878.31672,714.49952s-35.85889,14.34356-38.24949,14.34356S836.08291,770.28,836.08291,770.28s2.39059,24.7028-36.65575,32.67144,31.0777,25.49965,43.82753,16.73415,18.32788-15.14042,18.32788-15.14042l4.78118-7.96865L864.77,810.12324l5.578.79686,12.74982-25.49966s3.18746-19.12474-.79686-23.90592S878.31672,714.49952,878.31672,714.49952Z"
            transform="translate(-47 -52.54523)"
            fill="#2f2e41"
          />
          <polygon
            points="651.225 512.144 656.803 543.222 683.1 540.831 678.319 518.519 651.225 512.144"
            fill="#a0616a"
          />
          <path
            d="M827.3174,433.20644l-4.78118,7.96864S684.6787,422.05034,684.6787,473.04965s-6.37491,81.28016-7.96864,83.67075,41.43694,27.89025,50.99931,26.29652c0,0,6.37492-8.76551,5.578-19.92161s6.37492-52.593,0-54.98363c0,0,7.96864-3.18746,7.17178-7.96864,0,0,112.35786,15.93728,126.70142,12.74982s23.90593-13.54669,26.29652-19.9216,7.51091-31.24215,7.51091-31.24215l-1.136-42.06936-12.74983-15.14043-19.12474-2.39059-29.484,18.32788Z"
            transform="translate(-47 -52.54523)"
            fill="#2f2e41"
          />
          <path
            d="M912.58188,508.90854s-11.1561,25.49966,1.59373,25.49966,17.531-22.3122,17.531-22.3122Z"
            transform="translate(-47 -52.54523)"
            fill="#a0616a"
          />
          <path
            d="M827.3174,302.5207l-3.98432-4.78119s-44.6244-100.4049-27.09338-127.49828,94.03-31.07771,96.42057-29.484,9.56238,7.17178,8.76551,8.76551-16.73415,5.578-11.1561,15.14042c0,0-7.96864,2.39059-9.56237-.79686s-6.37491-3.98433-7.96864-.79687-27.09339,10.35924-27.09339,12.74983-3.98432,14.34356-7.96864,15.93729.79686,25.49965,8.76551,31.87457,13.54669,23.90592,13.54669,23.90592l-3.98432,35.8589Z"
            transform="translate(-47 -52.54523)"
            fill="#d0cde1"
          />
          <path
            d="M850.12219,168.43017c-4.76656,2.42659-9.507,5.52565-12.38153,10.40894-5.883,9.99425-2.12541,23.667-5.77,34.90875-1.55408,4.79351-4.38534,8.91288-6.72138,13.29456s-4.24229,9.39108-3.63048,14.44209c.60017,4.95493,3.51539,9.15749,4.89233,13.916,2.36958,8.189-.005,17.06735-2.68051,25.13845q-2.19747,6.62911-4.67437,13.13754c-.958,2.51715-2.10758,5.21407-4.30635,6.42679l18.85787,1.54729c5.4811.44972,11.53794.71457,15.84558-3.08942a18.28654,18.28654,0,0,0,4.12624-5.89848c4.25672-8.88945,4.94447-19.37175,4.45536-29.43319s-2.06273-20.05956-1.97666-30.13529a30.62859,30.62859,0,0,1,1.32144-9.77432,55.1572,55.1572,0,0,1,3.54233-7.17006c4.29823-8.28774,6.07375-17.85509,7.78708-27.23532,1.17494-6.43263,3.05044-15.7505-.31145-21.79439C865.14588,161.09442,854.65531,166.12243,850.12219,168.43017Z"
            transform="translate(-47 -52.54523)"
            fill="#2f2e41"
          />
          <circle cx="821.75435" cy="153.5549" r="32.67143" fill="#a0616a" />
          <path
            d="M856.00452,233.99037s5.17962,20.32,1.99216,30.67928,43.4291-13.94513,43.4291-13.94513-14.34356-19.12474-14.34356-25.49966Z"
            transform="translate(-47 -52.54523)"
            fill="#a0616a"
          />
          <path
            d="M915.76934,265.06808s-10.35924-7.96864-10.35924-11.953-7.17178-12.74982-7.17178-12.74982-34.26516,17.531-35.85889,17.531-2.39059-10.35924-2.39059-10.35924l-36.65576,50.20245s-11.953,28.68712-7.96864,50.99932,10.35924,45.42126,7.17178,66.13973.79686,27.89025,5.57805,25.49966,0-10.35924,10.35923-9.56237,45.42127-10.35924,47.81186-15.14043,11.953,10.35924,12.74983,19.12475-1.59373,32.67143,0,31.87457,3.98432-14.34356,4.78118-20.71847,3.18746-27.09339,0-30.28085-.79686-7.96864,1.59373-9.56237S946.847,305.70816,946.847,305.70816s-3.98432-20.71848-17.531-27.89025S915.76934,265.06808,915.76934,265.06808Z"
            transform="translate(-47 -52.54523)"
            fill="#d0cde1"
          />
          <path
            d="M934.09722,292.16146l12.74982,13.5467v71.71778s16.73415,86.06134,6.37492,90.84253-15.14042,3.18745-15.14042,3.18745,2.39059,43.82754-4.78119,43.82754-18.32788-3.18746-24.70279-1.59373c0,0,1.59373-15.93729,6.37491-23.10906s4.78119-19.92161,4.78119-19.92161-7.17178,0-7.17178-10.35924-.79686-16.73415-1.59373-19.12474-6.37491-44.6244-6.37491-44.6244Z"
            transform="translate(-47 -52.54523)"
            fill="#d0cde1"
          />
          <path
            d="M861.77982,166.77915c5.51586-3.50559,12.829-.85209,19.23558-2.14417,6.96414-1.40453,12.76773-7.478,19.86367-7.13226,5.90185.28757,10.56329,4.94185,14.385,9.44844a66.65609,66.65609,0,0,1,9.16636,13.12558c2.61759,5.25389,4.04182,11.00679,5.44668,16.706l4.71253,19.11793c1.59746,6.48062,3.2142,13.01561,6.11538,19.02672s7.22177,11.53783,13.08824,14.72136a38.50732,38.50732,0,0,1-22.01655.07092,45.156,45.156,0,0,0,13.25538,18.53539c-5.3149,1.62171-11.0417-.01285-16.58732.33949a23.54178,23.54178,0,0,0-19.07539,12.503c-2.89615,5.64753-3.34147,12.19246-5.07089,18.29913-5.16229,18.22836-23.13294,32.01237-42.07638,32.27381,5.31116-7.6559,10.88691-16.54241,8.82978-25.63028-1.24336-5.49285-5.16139-10.10443-6.32317-15.61511-1.2418-5.89023.81142-11.89865,2.20633-17.75451s1.97355-12.57886-1.65632-17.381c-3.84853-5.09147-11.57241-6.773-14.05412-12.65311a18.04434,18.04434,0,0,1-.97785-6.789l-.15859-10.4792a22.16342,22.16342,0,0,1,.55238-6.54411c.81682-2.8076,2.69728-5.16057,4.4904-7.47024,3.40694-4.38838,6.72111-9.05609,8.04169-14.4525,1.60356-6.55279-.88515-10.618-4.07719-15.9223C856.33455,176.39126,856.98955,169.82359,861.77982,166.77915Z"
            transform="translate(-47 -52.54523)"
            fill="#2f2e41"
          />
          <path
            d="M896.6446,146.3353S933.30035,178.20987,923.738,189.366s-24.70279-20.71847-24.70279-20.71847l-15.93729-11.953Z"
            transform="translate(-47 -52.54523)"
            fill="#a0616a"
          />
          <path
            d="M743.64666,574.25141s-42.23381,10.35924-47.015,19.12475c0,0-5.578,27.09338-5.578,38.24948s-2.3906,31.87457-24.7028,35.85889-38.24948,11.1561-7.96864,16.73415,39.04635,7.17178,47.81186-4.78118,13.54669-15.14042,13.54669-15.14042l6.37491,15.93728H730.1l15.14043-32.67143s1.59372-15.93729-2.3906-25.49966S743.64666,574.25141,743.64666,574.25141Z"
            transform="translate(-47 -52.54523)"
            fill="#2f2e41"
          />
          <path
            d="M901.02735,149.12433s-1.21823,12.74983-18.53856,15.14042l-3.77364-11.953,11.953-10.35923Z"
            transform="translate(-47 -52.54523)"
            fill="#d0cde1"
          />
          <circle cx="428.50536" cy="500.59912" r="86" fill="currentColor" />
          <path
            d="M431.7647,425.42408l-.00011,0a67.42193,67.42193,0,0,1-83.03721-36.49526L255.5083,179.57546A90.274,90.274,0,0,1,309.26257,57.269l.00018-.00007a90.27406,90.27406,0,0,1,116.8094,65.87319l50.04222,223.63905A67.42192,67.42192,0,0,1,431.7647,425.42408Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
          <circle cx="428.50536" cy="500.59912" r="86" opacity="0.1" />
          <path
            d="M431.7647,425.42408l-.00011,0a67.42193,67.42193,0,0,1-83.03721-36.49526L255.5083,179.57546A90.274,90.274,0,0,1,309.26257,57.269l.00018-.00007a90.27406,90.27406,0,0,1,116.8094,65.87319l50.04222,223.63905A67.42192,67.42192,0,0,1,431.7647,425.42408Z"
            transform="translate(-47 -52.54523)"
            opacity="0.1"
          />
          <circle cx="425.32461" cy="491.11847" r="69" fill="currentColor" />
          <path
            d="M423.56994,400.74915l-.0001,0a61.86135,61.86135,0,0,1-76.18878-33.48533L261.85015,175.1767A82.82877,82.82877,0,0,1,311.17107,62.95739l.00018-.00006a82.82878,82.82878,0,0,1,107.17563,60.44035l45.915,205.19459A61.86136,61.86136,0,0,1,423.56994,400.74915Z"
            transform="translate(-47 -52.54523)"
            fill="currentColor"
          />
        </svg>
        <h2 class="mb-6 text-xl">
          Your project has been terminated
        </h2>
        <p>{{ state.project.terminated_reason }}</p>
      </div>
    </div>
  </project-base>
</template>

<script>
export default {
  name: "ProjectTerminated",
  created() {
    window._project = this.state.project.uuid;
    document.title = `Project ${this.state.project.ref} Terminated`;
  }
};
</script>
